<ion-content class="background">
  <div class="space-32"></div>

  <ion-grid class="section-btn">
    <ion-row class="ion-justify-content-center">
      <ion-col size="12">
        <div class="library-list">
          <button (click)="openModalClave()" id="openModalClave" class="btn-option">
            <span> Cambiar Clave </span>
          </button>
        </div>
        <div class="library-list">
          <button (click)="openModalDatos()" id="openModalDatos" class="btn-option">
            <span> Editar mis Datos </span>
          </button>
        </div>
        <div class="library-list">
          <button (click)="closeModal()" id="closeModal" class="btn-primary btn-close">
            <span> Cerrar </span>
          </button>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
